import { jsx as o } from "react/jsx-runtime";
const s = (e) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    ...e,
    children: /* @__PURE__ */ o(
      "path",
      {
        stroke: "currentcolor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.667,
        d: "m10.008 15.494-3.341 2.005v-2.5H5a2.5 2.5 0 0 1-2.5-2.5V5.832a2.5 2.5 0 0 1 2.5-2.5h10a2.5 2.5 0 0 1 2.5 2.5v4.583M6.667 7.5h6.666m-6.666 3.332h5m1.666 5h5m-2.5-2.5v5"
      }
    )
  }
);
export {
  s as default
};
